import React from 'react';
import { ContentLink } from '../../../_lib/components/ContentLink';
import { FavoriteItem } from '../FavoritePagesTypes';

export function PageFavoriteInternalLink(item: FavoriteItem) {
  return <ContentLink to={item.content.pageLink.url}>{item.content.pageLink.name}</ContentLink>;
}
